class FantasticRgpd extends HTMLElement {
  constructor() {
    super();
    this.check = this.querySelector('#ff-check_legal');
    this.containerCheckbox = this.querySelector(".ff-acceptance-content")
    this.form = this.querySelector('form');
    this.button = this.querySelector('#ff-button-submit');
    this.error = this.querySelector('#ff-privacy-error');
    this.checkSubmit();
    this.checkChecked();
  }

  connectedCallback(){
    if (!this.containerCheckbox.dataset.newsletter) {
      this.containerCheckbox.style.marginBottom = `${this.check.nextElementSibling.offsetHeight + 30}px`
    }else{
      this.containerCheckbox.style.marginBottom = `${this.check.nextElementSibling.offsetHeight}px`

      if (screen.width < 1000) {
        document.querySelector(".footer-block__newsletter").style.marginBottom= `${this.check.nextElementSibling.offsetHeight}px`
      }
    }
  }

  checkSubmit() {
    this.button && 
      this.button.addEventListener('click', (event) => {
        this.check.checked ? 
          this.error.classList.add('ff-hide-element')
        :
        (
          event.preventDefault(),
          this.error.classList.remove('ff-hide-element')
        )
      })
  }
  checkChecked() {
    this.check && 
      this.check.addEventListener('click', (event) => {
        this.check.checked ? 
          this.error.classList.add('ff-hide-element')
        :
          this.error.classList.remove('ff-hide-element')
      })
  }
}

customElements.define("ff-legal-acceptance", FantasticRgpd);